<template>
  <div class="total">
    <div class="total-title">
      <el-checkbox v-model="chart.extra[canSetProperty]">
        {{ title }}
      </el-checkbox>
      <el-button
        v-if="chart.extra[canSetProperty]"
        type="text"
        class="total-button"
        @click="addTotal(listProperty)"
      >
        +添加
      </el-button>
    </div>
    <div class="position" v-if="chart.extra[canSetProperty] && positionProperty">
      <el-radio-group v-model="chart.extra[positionProperty]" size="small">
        <template v-if="positionProperty.includes('row')">
          <el-radio-button label="left">左</el-radio-button>
          <el-radio-button label="right">右</el-radio-button>
        </template>
        <template v-else-if="positionProperty.toLowerCase().includes('column')">
          <el-radio-button label="top">上</el-radio-button>
          <el-radio-button label="bottom">下</el-radio-button>
        </template>
      </el-radio-group>
    </div>
    <div class="list" v-ps v-if="chart.extra[canSetProperty]">
      <div v-for="total in chart.extra[listProperty]" :key="total.id" class="list-item">
        <span v-tip>{{ total.name }}</span>
        <i
          class="el-icon-edit-outline list-operation"
          style="font-size: 15px"
          @click="editTotal(total)"
        ></i>
        <i
          class="el-icon-delete list-operation"
          style="font-size: 15px"
          @click="delTotal(total)"
        ></i>
      </div>
    </div>
    <total-dialog
      ref="total"
      :operation="operation"
      :total="total"
      @submit="setTotal"
      :dimensions="chart.xAxisList"
    ></total-dialog>
  </div>
</template>

<script>
import { randomString } from "@/utils/common"
import TotalDialog from "@/views/Backend/Admin/Statistics/chartEdit/TotalDialog"

export default {
  name: "total",
  components: { TotalDialog },
  props: {
    chart: Object,
    title: String,
    canSetProperty: String,
    listProperty: String,
    positionProperty: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      operation: "addTotal",
      total: {
        name: "",
        axisId: null,
        method: "",
        type: "",
        group: "",
        unit: "",
        showThousands: false,
        range: "PAGE"
      }
    }
  },
  computed: {
    axisList() {
      return (
        this.dimensions
          ?.filter(dimension => !dimension.hidden && dimension.type !== "COLUMN")
          .map(dimension => ({ label: dimension.name, value: dimension.id })) || []
      )
    }
  },
  methods: {
    addTotal(from) {
      this.operation = "addTotal"
      this.total = this.$options.data().total
      this.total.id = randomString(10)
      if (from.includes("row")) this.total.type = "ROW"
      else this.total.type = "COLUMN"
      this.total.group = from
      this.$nextTick(() => {
        this.$refs.total?.open()
      })
    },
    editTotal(item) {
      this.operation = "editTotal"
      this.total = item
      this.$nextTick(() => {
        this.$refs.total?.open()
      })
    },
    delTotal(total) {
      this.chart.extra[total.group].splice(
        this.chart.extra[total.group].findIndex(t => t.id === total.id),
        1
      )
    },
    setTotal(total) {
      switch (this.operation) {
        case "addTotal":
          this.chart.extra[total.group].push(total)
          break
        case "editTotal":
          this.chart.extra[total.group].splice(
            this.chart.extra[total.group].findIndex(t => t.id === total.id),
            1,
            total
          )
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.total {
  margin-left: 20px;
  .total-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
  }
  .position {
    margin-bottom: 10px;
  }
  .total-button {
    padding: 0;
  }
  .list {
    flex: 1;
    .list-item {
      line-height: 30px;
      height: 30px;
      font-size: 13px;
      align-items: center;
      display: flex;
      background-color: #f5f5f5;
      border-radius: 4px;
      padding: 0 10px;
      margin-bottom: 5px;
      .list-operation {
        visibility: hidden;
        color: #909399;
        margin-right: 5px;
      }
      &:hover {
        .list-operation {
          visibility: visible;
        }
      }
    }
  }
}
</style>
